import {components} from '../configured';

export const {
  AppSetup,
  DataTable,
  LoadingSpinner,
  LoginPage,
  Navigation,
  PageContentWrapper,
  Router,
  Notifications,
} = components;
